module.exports = __webpack_public_path__ + "img/img27.b4188f8a.svg";